import type { InfinitePaginationInfo } from './types';

export const DEFAULT_INFINITE_PAGINATION_INFO: InfinitePaginationInfo = {
  dataPath: 'objects',
  limitPath: 'inputs.page.limit',
  paginateByPath: 'inputs.page.paginateBy',
  offsetPath: 'inputs.page.offset',
  hasMorePath: 'hasMore',
};
